import { InjectionToken } from '@angular/core';
import { SliderConfig } from '../models/slider-config';

/**
 * This is not a real service, but it looks like it from the outside.
 * It's just an InjectionTToken used to import the config object, provided from the outside
 */
export const SliderConfigService = new InjectionToken<SliderConfig>('SliderConfig');
